import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ProjectsApi } from 'api/api';
import { ProjectDto } from 'api/models';

const projectsApi = new ProjectsApi();

export const fetchProjects = createAsyncThunk(
  'projects/fetchProjects',
  async () => {
    const response = await projectsApi.apiProjectsGet({
      pageSize: -1,
      isActive: true,
    });
    return response.data.items as ProjectDto[];
  }
);

interface ProjectsState {
  items: ProjectDto[];
  loading: boolean;
  error: string | null;
}

const initialState: ProjectsState = {
  items: [],
  loading: false,
  error: null,
};

const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchProjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch projects';
      });
  },
});

export default projectsSlice.reducer;
